module.exports = "../content/0ac05bd644869bf38a2b3216fc2d06b0.svg";